


























































































































import {
  defineComponent,
  computed,
  ref,
  onMounted,
  nextTick,
  watch,
  onUnmounted,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import { LogoutIcon, UsergroupIcon, FileUnknownIcon, SettingIcon, UserIcon } from 'tdesign-icons-vue';

// 引入组件
import userConfig from '@/renderer/components/user/components/userConfig/index.vue';
import switchOrg from '@/renderer/components/user/components/switchOrg.vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import UserLogo from '@/renderer/components/user/components/UserLogo.vue';

// 引入compositions
import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';
import loginWithPhoneHandler from '@/renderer/components/login/compositions/loginWithPhoneHandler';
import userConfigHandler from '@/renderer/components/user/compositions/userConfigHandler';

// 引入工具类
import { IpcEvents } from '@/ipc-events';
import { PAY_SOURCE, openTeamPayDialog } from '@/renderer/scripts/composition/dialogHandler';
import user from '@/renderer/scripts/utils/user';
import smh from '@/renderer/scripts/smh';
import { phoneCompose } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import ConstantConfig, { FILE_MANAGE_ROUTE_LIST } from '@/renderer/scripts/utils/ConstantConfig';
import tips from '@/renderer/scripts/utils/tips';
import { isAdmin, isTeamAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import ipc from '@/renderer/scripts/utils/ipc';
import { i18n_t } from '@/locales/i18n';
import { httpUrl, CONSTANT_URL } from '@/renderer/scripts/http';
import { checkTransBeforeQuit } from '@/renderer/scripts/utils/transmission/helper';

import '@/renderer/assets/images/Icon/svg/personal.svg';
import '@/renderer/assets/images/Icon/svg/team.svg';
import '@/renderer/assets/images/Icon/svg/enterprise.svg';
import '@/renderer/assets/images/Icon/svg/org-channel-tag.svg';
import '@/renderer/assets/images/Icon/svg/temporary.svg';
import useSpaceCenter from '@/renderer/components/user/compositions/userSpaceHandler';

interface ManageCenterEntryConfig {
  icon: string;
  wording: string;
  route: string;
}
export default defineComponent({
  components: {
    UserLogo,
    UserIcon,
    userConfig,
    switchOrg,
    BaseIcon,
    FileUnknownIcon,
    SettingIcon,
    UsergroupIcon,
    LogoutIcon,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = context.root.$store;
    const showUserConfig = ref(false);
    const showSwitchOrg = ref(false);
    const showContent = ref(false);
    const showUsagePopup = ref(false);
    const showSignOut = ref(false);
    let updateUsageTimer: number | undefined; // 刷新用量定时器
    let updateOrgInfoTimer: number | undefined; // 刷新企业/个人、企业信息定时器

    const isTemporary = computed(() => vm.$store.getters.userBaseInfo.isTemporary);
    const isPersonal = computed(() => store.getters.editionFlag === 'personal');
    const isTeam = computed(() => store.getters.editionFlag === 'team');
    const orgName = computed(() => store.getters.orgName);
    const isChannel = computed(() => store.getters.orgChannel && !store.getters.channelUpdated);
    const userNickname = computed(() => store.getters.userBaseInfo.nickname);
    const userAvatar = computed(() => {
      const { avatar } = store.getters.userBaseInfo;
      if (!avatar) return '';
      return avatar.includes('http') ? avatar : `${store.getters.protocol}:${avatar}`;
    });
    const phoneNumber = computed(() => vm.$store.getters.userBaseInfo.phoneNumber);
    const countryCode = computed(() => vm.$store.getters.userBaseInfo.countryCode);
    const expiredTime = computed(() => store.getters.expireTime.split(' ')[0].replaceAll('-', '/'));
    const { usedSpace, totalSpace, percentSpace, hasPersonalSpace, isShareSpace } = useSpaceCenter();
    const { showSwitchOrgEntry } = userConfigHandler();
    const progressColor = computed(() => {
      return percentSpace.value > 80 ? { '70%': '#0444D9', '100%': '#ED515D' } : '#0444D9';
    });
    const methods = {
      // user-menu显示隐藏change
      onVisible(visible: boolean) {
        if (visible) {
          // 展示时查询一下是否所属多个企业
          store.dispatch('getOrgList');
        }
        showContent.value = visible;
      },
      // 打开产品反馈页
      openProductFeedbackPage() {
        dispatchRouter(CONSTANT_URL.productFeedbackUrl);
        showContent.value = false;
      },
      // 打开用户使用手册
      openCofileGuide() {
        dispatchRouter(httpUrl.staticCDNURLMap.userManualUrl);
        showContent.value = false;
      },
      // 退出登录注销
      signOut() {
        showSignOut.value = true;
        showContent.value = false;
        checkTransBeforeQuit({
          alwaysShowDialog: true,
          confirmFn: () => {
            showSignOut.value = false;
            user.signOut();
          },
          closeFn: () => {
            showSignOut.value = false;
          },
        });
      },
      // 更新查询使用量
      async updateUsage() {
        const { querySpaceTimestamp, hasPersonalSpace } = store.getters;
        // 没有个人空间不需要查询
        if (!hasPersonalSpace) return;
        // 离上次查询过querySpaceInterval后才再次请求
        if (new Date().getTime() - querySpaceTimestamp >= ConstantConfig.querySpaceInterval) {
          try {
            const res = await smh.userAPI.hasPersonalSpace();
            const { availableSpace = '0', capacity, size } = res.data;
            store.commit('SET_CAPACITY', capacity || '');
            store.commit('SET_SIZE', size);
            store.commit('SET_AVAILABLE_SPACE', availableSpace);
            store.commit('SET_QUERY_TIMESTAMP', new Date().getTime());
            store.commit('SET_AVAILABLE_PERCENT', percentSpace.value);
          } catch (e) {
            // 不提示 展示上次请求的用量
          }
        }
      },
      // 判断是否渲染usagePopup 溢出时渲染
      renderUsagePopup() {
        const [ele] = document.getElementsByClassName('usage');
        if (!ele) {
          showUsagePopup.value = false;
          return;
        }
        const usageWidth = ele.clientWidth;
        const usageScrollWidth = ele.scrollWidth;
        if (usageWidth < usageScrollWidth) {
          showUsagePopup.value = true;
        } else {
          showUsagePopup.value = false;
        }
      },
      // 更新 个人、企业信息
      async updateOrgInfo() {
        if (!store.getters.isLogined) return;
        const { organizationId } = user.getUserInfo();
        // 定时轮询个人空间状态，确保菜单展示状态实时更新
        store.dispatch('checkPersonalSpace');
        await store.dispatch('getUserBaseInfo').then(() => {
          // 管理员权限查询企业配额
          if (store.getters.userBaseInfo.role !== 'user') {
            store.dispatch('GetOrgSpace');
          }
        });
        store.dispatch('GetOrgInfo', organizationId);
      },
      initData() {
        // 初始化查询一次企业额度
        store.dispatch('GetOrgSpace');
        // 初始化获取一次是否有个人空间
        store.dispatch('checkPersonalSpace');
        methods.updateOrgInfo();
      },
      // 响应托盘菜单消息
      onTrayMenuEvent(e: any, param: any) {
        const { event, id } = param;
        switch (event) {
          case 'feedback':
            methods.openProductFeedbackPage();
            break;
          case 'help':
            methods.openCofileGuide();
            break;
          case 'swith-org':
            showUserConfig.value = false;
            showUsagePopup.value = false;
            showSignOut.value = false;
            showSwitchOrg.value = true;
            showContent.value = false;
            break;
          case 'setting':
          case 'update':
            showUserConfig.value = false;
            showUsagePopup.value = false;
            showSignOut.value = false;
            showSwitchOrg.value = false;
            showContent.value = false;
            break;
          default:
            break;
        }
      },
    };
    methods.initData();
    onMounted(() => {
      // 每隔60秒请求最新查询用量
      updateUsageTimer = window.setInterval(() => {
        methods.updateUsage();
      }, 1000 * 60);
      // 每隔5分钟请求最新查询用量
      updateOrgInfoTimer = window.setInterval(() => {
        methods.updateOrgInfo();
      }, 5 * 60 * 1000);
      ipc.on(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    });
    watch(usedSpace, () => {
      nextTick(() => {
        hasPersonalSpace.value && methods.renderUsagePopup();
      });
    });
    watch(userNickname, (newVal, oldVal) => {
      ipc.send(IpcEvents.UPDATE_MENU_DATA, {
        event: 'userName',
        param: newVal,
      });
    });
    watch(
      () => store.getters.showOrgList,
      (newVal, oldVal) => {
        if (newVal) {
          showSwitchOrg.value = true;
        }
      },
      {
        immediate: true,
      },
    );
    onUnmounted(() => {
      ipc.off(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
      window.clearInterval(updateUsageTimer);
      updateUsageTimer = undefined;
      window.clearInterval(updateOrgInfoTimer);
      updateOrgInfoTimer = undefined;
    });
    const handlerBuy = () => {
      openTeamPayDialog(PAY_SOURCE.SIDEBAR_ADCORNER);
    };

    // mock操作web、pc没有注销入口
    const deregister = async () => {
      const status = await smh.userAPI.checkDeregister();
      const { canDeregister } = status.data as any;
      if (canDeregister) {
        await smh.userAPI.deregister();
        tips.success(i18n_t('注销成功'));
      } else {
        tips.error(i18n_t('无法注销'));
      }
    };

    // 个人权限 或者 非管理员 不展示管理中心
    const shouldShowManageCenter = computed(() => !isPersonal.value && isAdmin.value);
    const { inGuide } = sidebarGuideHandler();
    const { getIndexPage } = loginWithPhoneHandler();

    // 处理管理中心入口点击
    const handleClickManageCenterEntry = async (route: string) => {
      // 新手引导模式不跳转
      if (inGuide.value === true) return;

      // 返回首页
      const goHome = async () => {
        const routerName = getIndexPage(); // 动态获取首页
        await dispatchRouter({
          name: routerName,
        });
      };
      if (route === 'return') {
        await goHome();
        return;
      }
      await dispatchRouter({
        name: route,
      });
      reporter.report('pv_control_center');
    };

    // 管理中心入口配置
    const getManageCenterEntryConfig = (isEnter: boolean): ManageCenterEntryConfig => {
      if (isEnter) {
        return {
          icon: 'manage-center',
          wording: i18n_t('管理中心'),
          route: isTeamAdmin.value ? 'teamManagement' : 'spaceStatistics',
        };
      }
      return {
        icon: 'quit-manage-center',
        wording: i18n_t('退出管理中心'),
        route: 'return',
      };
    };
    const manageCenterEntryConfig = computed(() => {
      // 根据当前页面判断是展示进入管理中心还是退出管理中心
      const menuValue = vm.$route.meta?.routerParent || vm.$route.name || '';
      if (FILE_MANAGE_ROUTE_LIST.includes(menuValue)) {
        const enterConfig = getManageCenterEntryConfig(true);
        return enterConfig;
      }
      const quitConfig = getManageCenterEntryConfig(false);
      return quitConfig;
    });
    return {
      expiredTime,
      userAvatar,
      orgName,
      userNickname,
      usedSpace,
      isShareSpace,
      isPersonal,
      isTeam,
      totalSpace,
      hasPersonalSpace,
      percentSpace,
      showUserConfig,
      showContent,
      showUsagePopup,
      showSwitchOrg,
      showSwitchOrgEntry,
      shouldShowManageCenter,
      manageCenterEntryConfig,
      isChannel,
      handlerBuy,
      deregister,
      handleClickManageCenterEntry,
      ...methods,
      isTemporary,
      phoneNumber,
      countryCode,
      phoneCompose,
      progressColor,
    };
  },
});
